var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList"),
      },
    },
    [
      _vm.wishListCount > 0
        ? _c("div", {
            staticClass: "dia-controls-list__item-badge",
            domProps: { innerHTML: _vm._s(_vm.wishListCount) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "svg",
        {
          attrs: {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M12.0815 21.4082L19.3284 28.6551C19.4791 28.8059 19.7236 28.8058 19.8743 28.655L27.1158 21.4082L27.6513 20.8782C28.6838 19.8457 29.1973 18.4764 29.1973 17.1182C29.1973 15.7545 28.6838 14.3907 27.6513 13.3583C25.5864 11.2933 22.2019 11.2933 20.1314 13.3583L19.6014 13.8938L19.0658 13.3583C17.0009 11.2933 13.6164 11.2933 11.5515 13.3583C10.5135 14.3907 10 15.7545 10 17.1182C10 18.4764 10.5135 19.8457 11.5515 20.8782L12.0815 21.4082ZM12.0815 21.4082L19.3284 28.6551C19.4791 28.8059 19.7236 28.8058 19.8743 28.655L27.1158 21.4082",
              stroke: "#F0C42E",
              "stroke-miterlimit": "10",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M11.5635 17.6328C11.5635 17.9128 11.5895 18.1933 11.6417 18.47",
              stroke: "#F0C42E",
              "stroke-miterlimit": "10",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M15.1547 13.2676C14.3119 13.4297 13.5079 13.8351 12.8593 14.4836C12.3799 14.9605 12.0341 15.5218 11.8203 16.1209",
              stroke: "#F0C42E",
              "stroke-miterlimit": "10",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M12.8813 20.5986L20.1282 27.8455C20.279 27.9963 20.5234 27.9963 20.6741 27.8454L27.9156 20.5986L28.4511 20.0686C29.4836 19.0361 29.9971 17.6669 29.9971 16.3087C29.9971 14.9449 29.4836 13.5812 28.4511 12.5487C26.3862 10.4838 23.0017 10.4838 20.9312 12.5487L20.4012 13.0843L19.8656 12.5487C17.8007 10.4838 14.4162 10.4838 12.3513 12.5487C11.3133 13.5812 10.7998 14.9449 10.7998 16.3087C10.7998 17.6669 11.3133 19.0361 12.3513 20.0686L12.8813 20.5986ZM12.8813 20.5986L20.1282 27.8455C20.279 27.9963 20.5234 27.9963 20.6741 27.8454L27.9156 20.5986",
              stroke: "#0E0F12",
              "stroke-miterlimit": "10",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M12.3633 16.8237C12.3633 17.1037 12.3893 17.3842 12.4416 17.6609",
              stroke: "#0E0F12",
              "stroke-miterlimit": "10",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M15.9545 12.4585C15.1117 12.6206 14.3077 13.026 13.6592 13.6745C13.1797 14.1514 12.8339 14.7127 12.6201 15.3118",
              stroke: "#0E0F12",
              "stroke-miterlimit": "10",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }